import React from "react"

const ColumnHeader = ({columnName}) => {
    return (
        <div className="top-0 min-w-24 text-white bg-blue-500 border-b py-2 text-center content-center border-r text-sm font-semibold border-black whitespace-pre-line">
            {columnName}
        </div>
    )
}

export default ColumnHeader;